require('babel-polyfill'); // necesario para ie11

const $ = require('jquery');
require('bootstrap');
import * as spinner from 'spinner';

$.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
});

function clearLoader() {
	let $loader = $('.ajax.loader, .ajax.dimmer');
	// $loader.remove();
	$loader.fadeOut(250, function() { $loader.remove()});
}
$(function () {
	$(document).ajaxStart(function () {
		// do nothing
	}).ajaxStop(function () {
		clearLoader();
		spinner.hide();
	}).ajaxError(function (event, jqxhr, settings, thrownError) {
		clearLoader();
		spinner.hide(true);

		if (jqxhr.aemps && jqxhr.aemps.handled) {
			console.log('handled, it\'s ok'); 
		} else {
			if (jqxhr.readyState == 0) {
				window.location = '';
			} else if (jqxhr.status == 401) {
				window.location = 'error/401';
			} else if (jqxhr.status == 500 && jqxhr.responseText) {
				// TODO pushState? ya que si no, al volver atrás no muestra la pantalla en la que se produjo el error
				let body = $(jqxhr.responseText).filter('#layout-body');
				$('#layout-body').html(body);
			} else {
				console.log(`Se ha producido un error en la petición. Status=${jqxhr.status}`);
				console.log(event);
				console.log(jqxhr);
				console.log(settings);
				console.log(thrownError);
	
				$('#aviso-error').modal();
			}
		}
	}).ajaxSend(function (event, jqxhr, settings) {
		if (['POST', 'PUT', 'DELETE'].includes(settings.type)) {
			let token = $("meta[name='_csrf']").attr("content");
			let header = $("meta[name='_csrf_header']").attr("content");
			jqxhr.setRequestHeader(header, token);
		}
	});
	
	$(':input[pattern]').change(function () {
		if (this.validity) {
			if (!this.validity.valid) {
				$(this).closest('div.form-group').addClass('has-error');
			} else {
				$(this).closest('div.form-group').removeClass('has-error');
			}
		}
	});
	
	$('[data-toggle="popover"]').popover({
		placement: 'auto',
		container: 'body',
		html: true,
		trigger: 'focus hover'
	}).click(function (e) {
		e.preventDefault();
	});

	if (window.aempsShowAcuerdo) {
		$('#acuerdo-uso').modal();
	}
});


// WEBPACK FOOTER //
// ./js/aemps/aemps.js